module.exports = __webpack_public_path__ + "static/media/logo-nodizurc.3216ffd3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo-nodizurc.png
// module id = 131
// module chunks = 0